module.exports = __webpack_public_path__ + "static/media/room.b75ecfb6.svg";